import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=175c53a2&"
import script from "./MultiSelect.vue?vue&type=script&lang=js&"
export * from "./MultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports